import ArticleBrightcoveMedia from "@routes/Article/components/ArticleMainMedia/ArticleMainBrightcove";
import ArticleYoutubeMedia from "@routes/Article/components/ArticleMainMedia/ArticleMainYoutube";
import ArticleThumbnail from "@routes/Article/components/ArticleThumbnail/ArticleThumbnail";
import { Type } from "@typings/enums";

export const ArticleMainMediaFactory = (type: string) => {
  switch (type) {
    case Type.ArticleYoutubeVideo:
      return ArticleYoutubeMedia;

    case Type.ArticleBrightcoveVideo:
      return ArticleBrightcoveMedia;

    default:
      return ArticleThumbnail;
  }
};

/**
 * Function to extract YouTube video ID from a URL.
 * It supports various YouTube URL formats.
 */
export const getYoutubeid = (url: string): string | undefined => {
  const match = url.match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  );

  return match ? match[1] : undefined;
};
